module.exports = __webpack_public_path__ + "img/planet-top-desktop.2c5c20c.webp";